var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerFirefoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 35C42.2 35 43.98 32.75 43.98 30L44 5C44 2.25 42.2 0 40 0H8C5.8 0 4 2.25 4 5V30C4 32.75 5.8 35 8 35H0V40H48V35H40ZM8 5H40V30H8V5Z",
    fill: "#495058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9525 13.3872C33.474 12.2723 32.5033 11.0686 31.7432 10.6881C32.2853 11.7044 32.6615 12.7959 32.8585 13.9238L32.8605 13.9416C31.6154 10.9371 29.5046 9.72367 27.7798 7.08502C27.6926 6.95157 27.6054 6.81785 27.5204 6.6767C27.4718 6.59609 27.4329 6.52345 27.3991 6.45659C27.3275 6.32247 27.2724 6.18073 27.2348 6.03424C27.2349 6.02748 27.2323 6.02094 27.2277 6.01586C27.2231 6.01079 27.2167 6.00753 27.2098 6.00672C27.203 6.00492 27.1959 6.00492 27.1891 6.00672C27.1876 6.00672 27.1854 6.0092 27.1837 6.00975C27.182 6.0103 27.1783 6.01278 27.1757 6.01388L27.18 6.00672C24.4137 7.57505 23.4746 10.4778 23.3893 11.9306C22.2842 12.004 21.2276 12.3982 20.3574 13.0617C20.2666 12.9873 20.1718 12.9177 20.0732 12.8532C19.8223 12.0027 19.8116 11.1026 20.0423 10.2467C19.0264 10.7232 18.1237 11.3987 17.3914 12.2305H17.3863C16.9498 11.6948 16.9805 9.92837 17.0055 9.5594C16.8764 9.60965 16.7531 9.67301 16.6378 9.74843C16.2525 10.0147 15.8923 10.3135 15.5614 10.6413C15.1844 11.0114 14.84 11.4115 14.5319 11.8373V11.839V11.8371C13.824 12.8088 13.3218 13.9066 13.0543 15.0673L13.0396 15.1377C13.0188 15.2315 12.9441 15.7015 12.9313 15.8036C12.9313 15.8115 12.9296 15.819 12.9287 15.8269C12.8323 16.3121 12.7726 16.8035 12.75 17.297V17.3521C12.7549 20.0206 13.7927 22.5904 15.6587 24.5541C17.5247 26.5179 20.0832 27.733 22.8291 27.9594C25.5751 28.1859 28.309 27.4073 30.491 25.7774C32.6731 24.1475 34.1449 21.7847 34.6157 19.1554C34.6342 19.0178 34.6493 18.8816 34.6658 18.7427C34.8926 16.9272 34.647 15.0857 33.9514 13.3856L33.9525 13.3872ZM21.2593 21.7351C21.3107 21.7591 21.3591 21.7849 21.4119 21.8078L21.4196 21.8125C21.3662 21.7877 21.3127 21.7619 21.2593 21.7351ZM32.8608 13.9447V13.9345L32.8628 13.9458L32.8608 13.9447Z",
    fill: "url(#paint0_linear_219_874)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9527 13.3867C33.4742 12.2718 32.5035 11.068 31.7434 10.6875C32.2854 11.7039 32.6616 12.7954 32.8587 13.9232V13.9334L32.8607 13.9447C33.7097 16.2969 33.5869 18.8759 32.518 21.1425C31.2558 23.7649 28.2017 26.4528 23.4193 26.3207C18.2534 26.179 13.7012 22.4659 12.8516 17.6041C12.6967 16.8373 12.8516 16.4485 12.9295 15.8253C12.8233 16.3094 12.764 16.802 12.7524 17.2968V17.3518C12.7573 20.0203 13.7952 22.5901 15.6612 24.5539C17.5271 26.5176 20.0856 27.7327 22.8316 27.9591C25.5775 28.1856 28.3114 27.407 30.4935 25.7771C32.6756 24.1472 34.1473 21.7844 34.6182 19.1551C34.6367 19.0175 34.6517 18.8813 34.6682 18.7424C34.895 16.927 34.6495 15.0854 33.9538 13.3853L33.9527 13.3867Z",
    fill: "url(#paint1_radial_219_874)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9527 13.3867C33.4742 12.2718 32.5035 11.068 31.7434 10.6875C32.2854 11.7039 32.6616 12.7954 32.8587 13.9232V13.9334L32.8607 13.9447C33.7097 16.2969 33.5869 18.8759 32.518 21.1425C31.2558 23.7649 28.2017 26.4528 23.4193 26.3207C18.2534 26.179 13.7012 22.4659 12.8516 17.6041C12.6967 16.8373 12.8516 16.4485 12.9295 15.8253C12.8233 16.3094 12.764 16.802 12.7524 17.2968V17.3518C12.7573 20.0203 13.7952 22.5901 15.6612 24.5539C17.5271 26.5176 20.0856 27.7327 22.8316 27.9591C25.5775 28.1856 28.3114 27.407 30.4935 25.7771C32.6756 24.1472 34.1473 21.7844 34.6182 19.1551C34.6367 19.0175 34.6517 18.8813 34.6682 18.7424C34.895 16.927 34.6495 15.0854 33.9538 13.3853L33.9527 13.3867Z",
    fill: "url(#paint2_radial_219_874)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5987 14.639C28.6226 14.6552 28.6447 14.6714 28.6672 14.6877C28.3905 14.2127 28.0462 13.7778 27.6442 13.3958C24.2201 10.0803 26.7471 6.20904 27.1731 6.01094L27.1773 6.00488C24.4111 7.57321 23.472 10.476 23.3867 11.9288C23.5152 11.9202 23.6425 11.9098 23.7737 11.9098C24.7552 11.9116 25.7186 12.1651 26.5661 12.6443C27.4135 13.1236 28.1149 13.8116 28.5987 14.6384V14.639Z",
    fill: "url(#paint3_radial_219_874)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7799 15.302C23.7617 15.5672 22.7939 16.4821 22.4555 16.4821C19.3241 16.4821 18.8154 18.3165 18.8154 18.3165C18.9541 19.8612 20.0657 21.134 21.4095 21.8053C21.4709 21.8362 21.5331 21.8639 21.5953 21.8912C21.7031 21.9374 21.8109 21.9802 21.9187 22.0194C22.3799 22.1774 22.8629 22.2677 23.3517 22.2871C28.8416 22.5364 29.9043 15.9313 25.9429 14.0135C26.8774 13.8958 27.8237 14.1182 28.5983 14.6378C28.1145 13.811 27.4132 13.123 26.5657 12.6437C25.7182 12.1645 24.7548 11.911 23.7734 11.9092C23.6427 11.9092 23.5148 11.9196 23.3864 11.9282C22.2813 12.0015 21.2247 12.3957 20.3544 13.0593C20.5223 13.1969 20.7119 13.3807 21.1111 13.7617C21.8584 14.4746 23.7751 15.2131 23.7793 15.2998L23.7799 15.302Z",
    fill: "url(#paint4_radial_219_874)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7799 15.302C23.7617 15.5672 22.7939 16.4821 22.4555 16.4821C19.3241 16.4821 18.8154 18.3165 18.8154 18.3165C18.9541 19.8612 20.0657 21.134 21.4095 21.8053C21.4709 21.8362 21.5331 21.8639 21.5953 21.8912C21.7031 21.9374 21.8109 21.9802 21.9187 22.0194C22.3799 22.1774 22.8629 22.2677 23.3517 22.2871C28.8416 22.5364 29.9043 15.9313 25.9429 14.0135C26.8774 13.8958 27.8237 14.1182 28.5983 14.6378C28.1145 13.811 27.4132 13.123 26.5657 12.6437C25.7182 12.1645 24.7548 11.911 23.7734 11.9092C23.6427 11.9092 23.5148 11.9196 23.3864 11.9282C22.2813 12.0015 21.2247 12.3957 20.3544 13.0593C20.5223 13.1969 20.7119 13.3807 21.1111 13.7617C21.8584 14.4746 23.7751 15.2131 23.7793 15.2998L23.7799 15.302Z",
    fill: "url(#paint5_radial_219_874)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8413 12.7074C19.9305 12.7625 20.0041 12.8103 20.0686 12.8535C19.8177 12.003 19.807 11.1029 20.0376 10.2471C19.0217 10.7236 18.119 11.3991 17.3867 12.2309C17.4404 12.2295 19.0379 12.2017 19.8413 12.7074Z",
    fill: "url(#paint6_radial_219_874)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8494 17.6052C13.6993 22.467 18.2512 26.1814 23.4171 26.3218C28.1994 26.4527 31.2541 23.7646 32.5157 21.1435C33.5847 18.8769 33.7074 16.298 32.8584 13.9457V13.9355C32.8584 13.9276 32.8567 13.9229 32.8584 13.9254L32.8604 13.9432C33.2511 16.4132 31.9537 18.8051 29.9251 20.4257L29.9188 20.4394C25.9662 23.5568 22.1841 22.3198 21.4198 21.8152C21.3663 21.7904 21.3129 21.7646 21.2595 21.7378C18.9553 20.6714 18.0031 18.6397 18.2077 16.8953C17.6607 16.9031 17.1231 16.7572 16.6601 16.4751C16.1971 16.1931 15.8284 15.7871 15.5988 15.3063C16.2038 14.9475 16.8935 14.7447 17.6023 14.7171C18.3111 14.6896 19.0154 14.8382 19.6481 15.1489C20.9521 15.7221 22.436 15.7786 23.7825 15.3063C23.7783 15.2196 21.8616 14.4809 21.1143 13.7683C20.7151 13.3872 20.5255 13.2037 20.3576 13.0658C20.2668 12.9914 20.172 12.9217 20.0734 12.8572C20.0081 12.814 19.9345 12.7673 19.8461 12.7111C19.0428 12.2054 17.4453 12.2332 17.3924 12.2346H17.3873C16.9509 11.6989 16.9815 9.93245 17.0066 9.56348C16.8774 9.61372 16.7542 9.67709 16.6389 9.7525C16.2535 10.0188 15.8933 10.3176 15.5625 10.6453C15.1841 11.0145 14.8383 11.4136 14.5287 11.8387C13.8208 12.8104 13.3186 13.9079 13.0511 15.0686C13.0457 15.0903 12.6544 16.7467 12.8474 17.6057L12.8494 17.6052Z",
    fill: "url(#paint7_radial_219_874)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6446 13.3953C28.0466 13.7777 28.391 14.2131 28.6675 14.6885C28.728 14.7328 28.7846 14.7768 28.8326 14.8195C31.3295 17.0482 30.0212 20.1986 29.9238 20.4215C31.9521 18.8033 33.2484 16.4098 32.8591 13.939C31.6134 10.9317 29.5004 9.71829 27.7784 7.07965C27.6912 6.9462 27.6039 6.81248 27.519 6.67133C27.4704 6.59071 27.4314 6.51808 27.3976 6.45122C27.3261 6.3171 27.271 6.17536 27.2334 6.02887C27.2334 6.02211 27.2309 6.01557 27.2263 6.01049C27.2217 6.00542 27.2153 6.00216 27.2084 6.00135C27.2016 5.99955 27.1944 5.99955 27.1876 6.00135C27.1862 6.00135 27.1839 6.00383 27.1822 6.00438C27.1805 6.00493 27.1768 6.00741 27.1743 6.00851C26.7483 6.20413 24.2219 10.0779 27.646 13.3907L27.6446 13.3953Z",
    fill: "url(#paint8_radial_219_874)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8321 14.8206C28.7841 14.778 28.7275 14.7339 28.667 14.6896C28.6445 14.6734 28.6224 14.6572 28.5985 14.6409C27.8239 14.1214 26.8775 13.8989 25.9431 14.0166C29.9042 15.9344 28.8415 22.5379 23.3519 22.2903C22.8631 22.2708 22.3801 22.1806 21.9189 22.0225C21.8111 21.9835 21.7033 21.9407 21.5955 21.8943C21.5333 21.8668 21.471 21.8393 21.4097 21.8085L21.4173 21.8131C22.1829 22.3191 25.9638 23.5554 29.9164 20.4374L29.9227 20.4237C30.0213 20.2008 31.3295 17.0504 28.8315 14.8217L28.8321 14.8206Z",
    fill: "url(#paint9_radial_219_874)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8159 18.3149C18.8159 18.3149 19.3242 16.4805 22.4559 16.4805C22.7943 16.4805 23.763 15.5657 23.7803 15.3004C22.4338 15.7727 20.95 15.7162 19.6459 15.1431C19.0132 14.8324 18.3089 14.6837 17.6001 14.7112C16.8913 14.7388 16.2016 14.9416 15.5967 15.3004C15.8262 15.7812 16.1949 16.1872 16.6579 16.4693C17.121 16.7513 17.6585 16.8972 18.2055 16.8894C18.0015 18.633 18.9534 20.6644 21.2573 21.732C21.3088 21.7559 21.3571 21.7818 21.4099 21.8046C20.065 21.1319 18.9545 19.8596 18.8159 18.3158V18.3149Z",
    fill: "url(#paint10_radial_219_874)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9529 13.3872C33.4744 12.2723 32.5037 11.0686 31.7436 10.6881C32.2857 11.7044 32.6619 12.7959 32.8589 13.9238L32.8609 13.9416C31.6158 10.9371 29.5051 9.72367 27.7802 7.08502C27.693 6.95157 27.6058 6.81785 27.5208 6.6767C27.4722 6.59609 27.4333 6.52345 27.3995 6.45659C27.3279 6.32247 27.2728 6.18073 27.2352 6.03424C27.2353 6.02748 27.2327 6.02094 27.2281 6.01586C27.2235 6.01079 27.2171 6.00753 27.2102 6.00672C27.2034 6.00492 27.1963 6.00492 27.1895 6.00672L27.1841 6.00975C27.1841 6.00975 27.1787 6.01278 27.1761 6.01388L27.1804 6.00672C24.4141 7.57505 23.475 10.4778 23.3897 11.9306C23.5182 11.9221 23.6455 11.9116 23.7768 11.9116C24.7582 11.9135 25.7216 12.1669 26.5691 12.6462C27.4166 13.1254 28.1179 13.8134 28.6017 14.6402C27.8271 14.1207 26.8808 13.8982 25.9463 14.0159C29.9074 15.9337 28.8447 22.5372 23.3551 22.2896C22.8663 22.2701 22.3833 22.1799 21.9221 22.0219C21.8143 21.9828 21.7065 21.94 21.5987 21.8936C21.5365 21.8661 21.4743 21.8386 21.4129 21.8078L21.4206 21.8125C21.3671 21.7877 21.3137 21.7619 21.2603 21.7351C21.3117 21.7591 21.36 21.785 21.4129 21.8078C20.068 21.1348 18.9575 19.8625 18.8188 18.3189C18.8188 18.3189 19.3272 16.4845 22.4589 16.4845C22.7973 16.4845 23.766 15.5697 23.7833 15.3044C23.779 15.2178 21.8624 14.479 21.1151 13.7664C20.7158 13.3853 20.5263 13.2018 20.3584 13.0639C20.2676 12.9895 20.1728 12.9199 20.0742 12.8554C19.8233 12.0049 19.8126 11.1048 20.0433 10.2489C19.0274 10.7254 18.1247 11.4009 17.3924 12.2327H17.3873C16.9508 11.697 16.9815 9.93058 17.0065 9.5616C16.8774 9.61185 16.7541 9.67522 16.6388 9.75063C16.2535 10.0169 15.8933 10.3157 15.5624 10.6435C15.1854 11.0136 14.841 11.4137 14.5329 11.8395C13.825 12.8112 13.3228 13.9088 13.0553 15.0695L13.0405 15.1399C13.0198 15.2337 12.9269 15.7103 12.9135 15.8126C12.8285 16.3046 12.7742 16.801 12.751 17.2993V17.3543C12.7558 20.0228 13.7937 22.5926 15.6597 24.5563C17.5257 26.5201 20.0842 27.7352 22.8301 27.9616C25.5761 28.1881 28.3099 27.4095 30.492 25.7796C32.6741 24.1497 34.1459 21.7869 34.6167 19.1576C34.6352 19.02 34.6503 18.8838 34.6667 18.7449C34.8936 16.9294 34.6486 15.0873 33.9529 13.3872Z",
    fill: "url(#paint11_linear_219_874)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_874",
    x1: 32.4948,
    y1: 9.413,
    x2: 14.7799,
    y2: 27.0646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7874 8.48083) scale(22.9597 22.2318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2628 17.5606) scale(22.9597 22.2318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1038 3.52857) scale(16.6316 16.1043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7053 23.339) scale(10.9315 10.5849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3732 15.6525) rotate(-13.1759) scale(5.7868 6.58277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9783 7.65575) scale(7.86542 7.61603)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2298 2.70327) scale(33.5587 32.4947)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4409 4.50484) rotate(83.7803) scale(23.8213 16.1338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9785 10.4073) scale(20.9479 20.2837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_219_874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3777 11.5078) scale(22.9285 22.2015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_219_874",
    x1: 32.2736,
    y1: 9.3222,
    x2: 17.22,
    y2: 24.8715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerFirefoxIcon);
export default __webpack_public_path__ + "static/media/computer_firefox_icon.94fbf4aa.svg";
export { ForwardRef as ReactComponent };